import { useContext } from 'react';

import { UserContext } from '../user/User.context';
import { Guard } from './guard';

export default function NoRoleGuard(): Guard {
  const { user } = useContext(UserContext);
  return { canActivate: () => user?.roles?.length === 0 };
}
